export const appAdminSettingRoutes: any[] = [
    {
        path: "/admin/settings/usermanagement",
        section: "usermanagement",
        sidebarProps: {
            displayText: "User management",
            icon: 'manage_accounts',
        },
        child: [
            {
                path: "/admin/settings/users",
                section: "settingsusers",
                sidebarProps: {
                    displayText: "Users",
                },
            },
            {
                path: "/admin/settings/user-roles",
                section: "settingsuserroles",
                sidebarProps: {
                    displayText: "User Roles",
                },
            },
            {
                path: "/admin/settings/access-control",
                section: "settingsaccesscontrol",
                sidebarProps: {
                    displayText: "Access Control",
                },
            },
        ],
    },
    {
        path: "/admin/settings/logs",
        section: "logs",
        sidebarProps: {
            displayText: "Logs",
            icon: 'security',
        },
        child: [
            {
                path: "/admin/settings/audit-logs",
                section: "settingsauditlogs",
                sidebarProps: {
                    displayText: "Audit Logs",
                },
            }
        ],
    },
    {
        path: "/admin/settings/status",
        section: "status",
        sidebarProps: {
            displayText: "Status",
            icon: 'label',
        },
        child: [
            {
                path: "/admin/settings/vendor-status",
                section: "settingsvendorstatus",
                sidebarProps: {
                    displayText: "Vendor Status",
                },
            }
        ],
    },
    {
        path: "/admin/settings/inventorymanagement",
        section: "inventorymanagement",
        sidebarProps: {
            displayText: "Inventory Management",
            icon: 'inventory',
        },
        child: [
            {
                path: "/admin/settings/tire-inventory",
                section: "settingstireinventory",
                sidebarProps: {
                    displayText: "Tire Inventory",
                },
            },
            {
                path: "/admin/settings/wheel-inventory",
                section: "settingswheelinventory",
                sidebarProps: {
                    displayText: "Wheel Inventory",
                },
            },
            {
                path: "/admin/settings/tire-fitment",
                section: "settingstirefitment",
                sidebarProps: {
                    displayText: "Tire Fitment",
                },
            },
            {
                path: "/admin/settings/tire-brands",
                section: "settingstirebrands",
                sidebarProps: {
                    displayText: "Tire Brands",
                },
            },
            {
                path: "/admin/settings/tire-models",
                section: "settingstiremodels",
                sidebarProps: {
                    displayText: "Tire Models",
                },
            },
            {
                path: "/admin/settings/tire-products",
                section: "settingstireproducts",
                sidebarProps: {
                    displayText: "Tire Products",
                },
            },
            {
                path: "/admin/settings/wheel-fitment",
                section: "settingswheelfitment",
                sidebarProps: {
                    displayText: "Wheel Fitment",
                },
            },
            {
                path: "/admin/settings/wheel-brands",
                section: "settingswheelbrands",
                sidebarProps: {
                    displayText: "Wheel Brands",
                },
            },
            {
                path: "/admin/settings/wheel-models",
                section: "settingswheelmodels",
                sidebarProps: {
                    displayText: "Wheel Models",
                },
            },
            {
                path: "/admin/settings/wheel-products",
                section: "settingswheelproducts",
                sidebarProps: {
                    displayText: "Wheel Products",
                },
            },

        ],
    },
    {
        path: "/admin/settings/vehicle",
        section: "vehicle",
        sidebarProps: {
            displayText: "Vehicle",
            icon: 'directions_car',
        },
        child: [
            {
                path: "/admin/settings/vehicle-make",
                section: "settingsvehiclemake",
                sidebarProps: {
                    displayText: "Vehicle Make",
                },
            },
            {
                path: "/admin/settings/vehicle-model",
                section: "settingsvehiclemodel",
                sidebarProps: {
                    displayText: "Vehicle Model",
                },
            }
        ],
    },
    {
        path: "/admin/settings/service",
        section: "service",
        sidebarProps: {
            displayText: "Service",
            icon: 'car_repair',
        },
        child: [
            {
                path: "/admin/settings/service-types",
                section: "settingsservicetypes",
                sidebarProps: {
                    displayText: "Service Types",
                },
            },
            {
                path: "/admin/settings/blockdays",
                section: "settingsblockeddays",
                sidebarProps: {
                    displayText: "Blocked Days",
                },
            },
            {
                path: "/admin/settings/locations",
                section: "settingslocations",
                sidebarProps: {
                    displayText: "Locations",
                },
            },
        ],
    },
    {
        path: "/admin/settings/report",
        section: "report",
        sidebarProps: {
            displayText: "Report",
            icon: 'analytics',
        },
        child: [
            {
                path: "/admin/settings/financials",
                section: "settingsfinancials",
                sidebarProps: {
                    displayText: "Financials",
                },
            },
            {
                path: "/admin/settings/charts",
                section: "settingscharts",
                sidebarProps: {
                    displayText: "Charts",
                },
            }
        ],
    },
    {
        path: "/admin/settings/payments",
        section: "payments",
        sidebarProps: {
            displayText: "Payments",
            icon: 'payments',
        },
        child: [
            {
                path: "/admin/settings/terminals",
                section: "settingsterminals",
                sidebarProps: {
                    displayText: "Terminals",
                },
            },
            {
                path: "/admin/settings/payment-gateway-settings",
                section: "settingspaymentgatewaysettings",
                sidebarProps: {
                    displayText: "Payment Gateway Settings",
                },
            },
            {
                path: "/admin/settings/payment-gateways",
                section: "settingspaymentgateways",
                sidebarProps: {
                    displayText: "Payment Gateways",
                },
            },
            {
                path: "/admin/settings/transactions",
                section: "settingstransactions",
                sidebarProps: {
                    displayText: "Transactions",
                },
            },
            {
                path: "/admin/settings/credit-cards",
                section: "settingscreditcards",
                sidebarProps: {
                    displayText: "Credit Cards",
                },
            }
        ],
    }
];